// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1NHfs","content":"RecentSearches_content__A59Ep"};